import React, { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import ProjectsIcon from "@mui/icons-material/Construction";
import DocumentsIcon from "@mui/icons-material/Description";
import ReviewCheckIcon from "@mui/icons-material/Approval";
import PolicyIcon from "@mui/icons-material/Policy";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import { useTheme, useMediaQuery } from "@mui/material";
import useStore from "hooks/useStore";

const CompanyMenu = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const isUserAdministrator = useStore((state) => state.isUserAdministrator)();
  const isUserPublic = useStore((state) => state.isUserPublic)();
  const hasContractsApproverPermissionsInActiveCompany = useStore(
    (state) => state.hasContractsApproverPermissionsInActiveCompany
  )();
  const hasContractsCompilerPermissionsInActiveCompany = useStore(
    (state) => state.hasContractsCompilerPermissionsInActiveCompany
  )();

  const onMenuItemClick = (path) => {
    if (isMobile) {
      toggleDrawer();
    }
    startTransition(() => navigate(path));
  };

  return (
    <React.Fragment>
      {isUserAdministrator && (
        <ListSubheader component="div" inset>
          Company
        </ListSubheader>
      )}
      <ListItemButton onClick={() => onMenuItemClick(`/projects`)}>
        <ListItemIcon>
          <ProjectsIcon />
        </ListItemIcon>
        <ListItemText primary="Manage projects" />
      </ListItemButton>
      {(isUserAdministrator ||
        hasContractsCompilerPermissionsInActiveCompany) && (
        <ListItemButton onClick={() => onMenuItemClick(`/tenders`)}>
          <ListItemIcon>
            <DocumentsIcon />
          </ListItemIcon>
          <ListItemText primary="Tenders" />
        </ListItemButton>
      )}
      {(isUserAdministrator ||
        hasContractsCompilerPermissionsInActiveCompany) && (
        <ListItemButton onClick={() => onMenuItemClick(`/contracts`)}>
          <ListItemIcon>
            <DocumentsIcon />
          </ListItemIcon>
          <ListItemText primary="Contracts" />
        </ListItemButton>
      )}
      {(isUserAdministrator ||
        hasContractsCompilerPermissionsInActiveCompany) && (
        <ListItemButton onClick={() => onMenuItemClick(`/others`)}>
          <ListItemIcon>
            <DocumentsIcon />
          </ListItemIcon>
          <ListItemText primary="Short Agreements" />
        </ListItemButton>
      )}
      {(isUserAdministrator ||
        hasContractsCompilerPermissionsInActiveCompany) && (
        <ListItemButton
          onClick={() =>
            startTransition(() => navigate(`/contractual-notices`))
          }
        >
          <ListItemIcon>
            <DocumentsIcon />
          </ListItemIcon>
          <ListItemText primary="Contractual Notices" />
        </ListItemButton>
      )}
      {(isUserAdministrator ||
        hasContractsApproverPermissionsInActiveCompany) && (
        <ListItemButton onClick={() => onMenuItemClick(`/reviews`)}>
          <ListItemIcon>
            <ReviewCheckIcon />
          </ListItemIcon>
          <ListItemText primary="Reviews" />
        </ListItemButton>
      )}
      <ListItemButton onClick={() => onMenuItemClick(`/view-user-manual`)}>
        <ListItemIcon>
          <AutoStoriesIcon />
        </ListItemIcon>
        <ListItemText primary="View User Manual" />
      </ListItemButton>
      <ListItemButton onClick={() => onMenuItemClick("/view-tnc")}>
        <ListItemIcon>
          <PolicyIcon />
        </ListItemIcon>
        <ListItemText primary="Terms & Conditions" />
      </ListItemButton>
    </React.Fragment>
  );
};

export default CompanyMenu;
